import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminProvider } from "./context/AdminContext";
import { LanguageProvider } from "./context/LanguageContext";
import HomePage from "./pages/HomePage";
import SandwichMenuPage from "./pages/SandwichMenuPage";
import AdminLogin from "./pages/AdminLogin";

function App() {
  return (
    <LanguageProvider>
      <AdminProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/primo" element={<SandwichMenuPage />} />
              <Route path="/gestion-auleverprimomenu2026" element={<AdminLogin />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AdminProvider>
    </LanguageProvider>
  );
}

export default App;
